<div class="post-wrapper" id="{{post.id}}">
  <div class="row" *ngIf="updateObj.id !== post.id">
    <div class="column medium-12">
      <div class="row post post-border">
        <div class="medium-12">
          <div class="row post-user">
            <div class="round bot-image-name" *ngIf="post.user && post.user.bot">
              <img src="https://static.taxplaniq.com/futurefirm/favicon_new.png">
            </div>
            <div class="post-user-section" [ngClass]="{'medium-8': isDraftTaxPage, 'medium-8': !isDraftTaxPage, 'new-post-width': post.new}">
              <ng-template [ngIf]="post.user && post.user.bot">
                <span class="user">Jaine</span>
              </ng-template>
              <ng-template [ngIf]="post.user && !post.user.bot">
                <span class="user" style="cursor: pointer" (click)="displayInfo()">{{post.user.firstName}}</span>
                <span class="user" style="cursor: pointer" (click)="displayInfo()">{{post.user.lastName}}</span>
              </ng-template>
              <span class="commonColor2 post-dateTime-dropdown">
                  <span class="display-date">{{post.displayDate}}</span>
                  <span class="tooltip-date">{{post.tooltipDate}}</span>
                </span>
            </div>
            <div [ngClass]="{'medium-2': isDraftTaxPage, 'medium-1': !isDraftTaxPage}"></div>
            <div class="text-right update-dropdown post-right-options medium-2" [hidden]="!isQountOrgUser">
              <ul class="vertical medium-horizontal menu" *ngIf="post.user && (user.id === post.user.id)">
                <li class="is-dropdown-submenu-parent opens-left">
                  <i class="material-icons pointer more-horiz post_options" aria-hidden="true">more_horiz</i>
                  <ul class="vertical menu post-option-wrapper is-dropdown-submenu position-absolute" (clickOutside)="hidePostOptions()">
                    <li class="is-dropdown-submenu-item other-option" *ngIf="(post.user && (user.id === post.user.id)) && (post.entityType !== 'task')"><a href="javascript:void (0)" (click)="handlePostAction('edit')">Edit Message</a></li>
                    <li class="is-dropdown-submenu-item other-option" *ngIf="(post.user && (user.id === post.user.id))"><a href="javascript:void (0)" (click)="handlePostAction('delete')">Delete</a></li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>

          <div class="row post-body" *ngIf="post.documents.length > 0">
            <div class="column medium-5 attachment" *ngFor="let attachment of post.documents">
              <div class="row post-uploaded-doc">
                <div class="medium-9 pointer file-font" attr.title="{{attachment.name}}" *ngIf="!attachment.imageType">
                  <div class="attachment_name" (click)="downloadDocument(attachment, 'preview')">{{attachment.name}}</div>
                </div>
                <div class="medium-9 commonColor2  pointer" attr.title="{{attachment.name}}" *ngIf="attachment.imageType">
                  <img class="image-zoom" [src]="attachment.temporaryURL" (click)="openImage(attachment)" />
                </div>
                <div class="column medium-3 post-icons">
                  <i class="icon ion-ios-cloud-download-outline commonColor2 float-right post-icons-pad" (click)="downloadDocument(attachment, 'download')"></i>
                  <i class="icon ion-ios-trash commonColor2 remove-upload float-right" (click)="removeAttachment(attachment.id, post)"></i>
                </div>
              </div>
            </div>
            <div class="column medium-5"></div>
          </div>


          <div class="row post-body" *ngIf="post.isBotMessage && post.entityType != 'WallFile'">
            <div class="column medium-12">
              <span class="mentioned-users" style="font-size: 14px" *ngIf="post.mentionIds && post.mentionIds.length > 0">{{post.mention_message}}</span>
              <pre class="post-pre" *ngIf="!post.html_message" [froalaView]="post.message | linky:{stripPrefix: false}"></pre>
              <pre class="post-pre" *ngIf="post.html_message" [froalaView]="post.html_message | linky:{stripPrefix: false}"></pre>
            </div>
          </div>
           <div class="row post-body" *ngIf="post.isBotMessage && post.entityType === 'WallFile'">
            <div class="column medium-12">
              <span class="post-pre" (click)="processFile()" [innerHTML]="post.fileNameMessage | linky:{stripPrefix: false}"></span>
              <span class="post-pre" >{{post.message | split }}</span>
            </div>
          </div>

          <div class="row post-body post-snapshot margin-top-10" [style.background-color]="post.snapshotColor" *ngIf="post.entityType === 'team summary'">
            <div class="column medium-4 zero-padding">
              <img src="./images/snapshot/{{post.message.imageType || 'default'}}.png" class="summary-post-img">
            </div>
            <div class="column medium-8 task-summary">
              <div class="row">
                <div class="task-summary-head medium-12">Snapshot for {{post.tooltipDate}} has arrived</div>
                <div class="column medium-4 no-padding">
                  <div><span>Not Done:</span><span class="snapshot-items">{{post.message.NotDone}}</span></div>
                  <div><span>Blocked:</span><span class="snapshot-items">{{post.message.Blocked}}</span></div>
                  <div><span>Today:</span><span class="snapshot-items">{{post.message.dueToday}}</span></div>
                  <div><span>This Week:</span><span class="snapshot-items">{{post.message.dueThisWeek}}</span></div>
                  <div><span>Payme:</span><span class="snapshot-items">{{post.message.Payme}}</span></div>
                </div>
                <div class="column medium-8 team-summary">
                  <div><span>Not Done:</span><span  class="snapshot-items" title="{{post.message.tasksNotDone.userName}}">{{post.message.tasksNotDone.firstName}}</span><span>{{post.message.tasksNotDone.count}}</span></div>
                  <div><span>Past Due:</span><span class="snapshot-items" title="{{post.message.tasksNotDone.userName}}" *ngIf="post.message.tasksPastDue">{{post.message.tasksPastDue.firstName}}</span><span *ngIf="post.message.tasksPastDue">{{post.message.tasksPastDue.count}}</span></div>
                  <div><span>Yesterday:</span><span class="snapshot-items" title="{{post.message.tasksNotDone.userName}}">{{post.message.tasksClosedYesterday.firstName}}</span><span>{{post.message.tasksClosedYesterday.count}}</span></div>
                  <div><span>Last Week:</span><span class="snapshot-items" title="{{post.message.tasksNotDone.userName}}">{{post.message.tasksClosedLastWeek.firstName}}</span><span>{{post.message.tasksClosedLastWeek.count}}</span></div>
                  <div class="default_1_img"><img src="./images/snapshot/{{post.bottomSnapShot}}.png" *ngIf="post.message.imageType === 'default'"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="row post-body post-snapshot margin-top-10" [style.background-color]="post.snapshotColor" *ngIf="post.entityType === 'Task Summary'">
            <div class="column medium-4 zero-padding">
              <img src="./images/snapshot/{{post.message.imageType || 'default'}}.png" class="summary-post-img">
            </div>
            <div class="column medium-8 task-summary">
              <div class="row">
                <div class="task-summary-head medium-12">Snapshot for {{post.tooltipDate}} has arrived</div>
                <div class="column medium-4">
                  <div><span>Not Done:</span><span class="snapshot-items">{{post.message.NotDone}}</span></div>
                  <div><span>In Progress:</span><span class="snapshot-items">{{post.message.InProgress}}</span></div>
                  <div><span>Blocked:</span><span class="snapshot-items">{{post.message.Blocked}}</span></div>

                </div>
                <div class="column medium-8">
                  <div><span>Due Today:</span><span class="snapshot-items">{{post.message.dueToday}}</span></div>
                  <div><span>Due This Week:</span><span class="snapshot-items">{{post.message.dueThisWeek}}</span></div>
                  <div><span>Payme:</span><span class="snapshot-items">{{post.message.Payme}}</span></div>
                  <div class="default_2_img"><img src="./images/snapshot/{{post.bottomSnapShot}}.png" *ngIf="post.message.imageType === 'default'"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="column medium-12 post-selected-reactions no-padding">
            <qount-selected-reactions [setData]="post" *ngIf="post.allReactions"></qount-selected-reactions>
          </div> -->
          <hr>
          <div class="row">
            <div class="column medium-10 post-footer commonColor3">
              <div class="float-left" *ngIf="post.user && user.id === post.user.id">
                <label for="nativeFileUploadUpdate{{post.id}}" class="button upload_button">
                  <span><i class="material-icons">attach_file</i></span>
                </label>
                <input type="file" id="nativeFileUploadUpdate{{post.id}}" (change)="startUpload($event, 'updatePost', post.id)" value="null" class="show-for-sr" ng2FileSelect [uploader]="uploader" multiple/>
              </div>
              <div class="float-left more-comments-wrapper" (click)="openComments()">
                <span><i class="material-icons comment-icon">comment</i></span>
                <span class="pointer">{{post.comments.length}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="column medium-12">
      <div class="row edit-post" *ngIf="updateObj.id === post.id">
        <div class="medium-12">
          <div class="row">
            <div class="column medium-12 current-mentions" *ngIf="mentions && mentions.length > 0">
              You have mentioned:
              <span class="mentioned-users">{{mentions}}</span>
            </div>
            <div class="column medium-12">
              <div class="export-option metaData" *ngIf="updateObj.metaData">{{'['+updateObj.metaData+']'}}</div>
              <div class="export-option">
                <div class="post-textarea" #editPostEditor *ngIf="!updateObj.html_message" [froalaEditor]="editorOptions" [(ngModel)]="updateObj.message" placeholder= 'Compose Message ...' rows="3" (keydown.escape)="stopEditing()"></div>
                <div class="post-textarea" #editPostEditor *ngIf="updateObj.html_message" [froalaEditor]="editorOptions" [(froalaModel)]="updateObj.html_message" placeholder= 'Compose Message ...' rows="3" (keydown.escape)="stopEditing()"></div>
              </div>
              <div id="editorContainer"></div>
              <div class="postAttachment" *ngIf="updateObj.documentName">
                <div class="row">
                  <div class="column medium-3 commonColor2 pointer" attr.title="{{updateObj.documentName}}">
                    <div class="attachment_name">{{updateObj.documentName}}</div>
                  </div>
                  <div class="column medium-1">
                    <i class="icon ion-ios-trash commonColor2" (click)="removeAttachment(updateObj.id, updateObj)"></i>
                  </div>
                </div>
              </div>
              <div class="giphy-edit" *ngIf="isGify">
                <div class="medium-3 columns" style="top: 10px">
                  <div class="medium-10 columns">
                    <img style="height: 150px" class="gif" [src]="this.gifyUrl"/>
                  </div>
                  <div class="medium-1 columns giphy-del">
                    <i class="icon ion-ios-trash commonColor2 remove-upload float-right" (click)="removeGiphy(this.gifyUrl)"></i>
                  </div>
                </div>
              </div>
              <hr class="upload-area-hr">

              <div class="row badge-dropdown">
                <div class="column medium-10 post-footer commonColor3 margin-top-10">
                  <div class="float-left">
                    <label for="nativeFileUpload{{updateObj.id}}" class="button upload_button">
                      <span><i class="material-icons">attach_file</i></span>
                      <span class="commonColor3">Attach File</span>
                    </label>
                    <input type="file" id="nativeFileUpload{{updateObj.id}}" (change)="startUpload($event, 'updatePost', updateObj.id)" value="null" class="show-for-sr" ng2FileSelect [uploader]="uploader" multiple/>
                  </div>
                </div>
                <div class="column medium-2 text-right" (click)="onUpdateEnter($event, 'post')">
                  <button class="button small update-btn">UPDATE</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--comments-->
  <div class="row" *ngIf="!post.isOrgBroadcast && !hideComments">
    <div class="column medium-12">
      <!--new comment when task post-->
      <app-new-comment *ngIf="post.taskId" [user]="user" [postId]="post.id" [taskId]="post.taskId" [channelType] = "channelType"
                                     [pageType]="pageType" [post]="post" [companyId]="companyId" [org]="org"
                                     (onDeleteAttachment)="removeAttachment($event)"
                                     (onRefreshPost)="refreshPost()"
                       [draftMessage]="post.draft ? post.draft.newMessage: ''" [displayType]="displayType" [clientInternalUsers]="clientInternalUsers">
      </app-new-comment>

      <app-comment *ngFor="let comment of post.comments" [comment]="comment" [taskId]="taskId" [postId]="post.id" [org]="org"
                                 [entityID]="post.entityID" [entityType]="post.entityType" [companyId]="companyId" [user]="user" [isDocView]="isDocView"
                                 (onDeleteComment)="handleCommentAction($event)" [pageType]="pageType" [channelType] = "channelType">
      </app-comment>

      <!--new comment when not a task post-->
      <app-new-comment *ngIf="!post.taskId" [taskId]="taskId" [user]="user" [postId]="post.id" [channelType] = "channelType" [org]="org"
                                     [pageType]="pageType" [post]="post" [companyId]="companyId"
                                     (onDeleteAttachment)="removeAttachment($event)"
                                     (onRefreshPost)="refreshPost()" [draftMessage]="post.draft ? post.draft.newMessage: ''" [displayType]="displayType" [clientInternalUsers]="clientInternalUsers">
      </app-new-comment>
    </div>
  </div>

</div>
